<template>
  <div>
    <Title :pages="[{ icon: 'receipt', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <ModalPurchaseRemito
        v-if="create_access"
        :remito="mainItem"
        :formBtn="formBtn"
        :dialog="dialog"
        @closeDialog="close"
        @reload="filter"
        @updateItem="
          (newItem) => {
            remito = newItem;
          }
        "
        @updateDialog="updateDialog"
      />

      <ModalAsignacionGasto :remito="remitoAsignacionGasto" :dialog="dialogAsignacionGasto" @closeDialog="dialogAsignacionGasto = false" @reload="filter" />

      <DialogGenerarSpent
        title="Generar Gasto"
        :open="open_generate_spent"
        @closeDialog="closeSpent"
        @reload="filter"
        :item="spent_to_generate"
        formBtn="Crear"
        :purchase_remito="purchase_remito_to_generate"
      />

      <v-btn color="primary" class="mb-5" dark @click="dialog = true">Crear Remito</v-btn>

      <v-card>
        <div class="row mb-5 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-menu
                    ref="desde_selected"
                    v-model="desde_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-menu
                    ref="hasta_selected"
                    v-model="hasta_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="supplier_selected"
                    autocomplete="off"
                    data-vv-as="supplier_selected"
                    name="supplier_selected"
                    item-text="name"
                    item-value="id"
                    :items="suppliers"
                    label="Proveedor"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="receiver_selected"
                    autocomplete="off"
                    data-vv-as="receiver_selected"
                    name="receiver_selected"
                    item-text="name"
                    item-value="id"
                    :items="receivers"
                    label="Receptor"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="state_selected"
                    autocomplete="off"
                    data-vv-as="state_selected"
                    name="state_selected"
                    item-text="name"
                    item-value="id"
                    :items="states"
                    label="Estado"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-text-field clearable v-model="spent_number_selected" autocomplete="off" class="pt-0 mt-0" label="Nº Gasto"> </v-text-field>
                </div>

                <div class="col-md-3 pt-0">
                  <v-text-field clearable v-model="remito_number_selected" autocomplete="off" class="pt-0 mt-0" label="Nº Remito"> </v-text-field>
                </div>

                <div class="col-md-3 pt-0" style="display: flex; justify-content: flex-end">
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <div v-if="selected.length != 0" class="col-md-12" style="background: #f4f1f1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="green" class="cursor mb-1 mt-1" @click="generateSpentModal">post_add</v-icon>
            </template>
            <span>Generar gasto</span>
          </v-tooltip>
        </div>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
          v-model="selected"
          show-select
          :single-select="false"
        >
          <template v-slot:item="{ item, isSelected, select }">
            <tr>
              <td>
                <v-checkbox :input-value="isSelected" style="margin: 0px; padding: 0px" hide-details @change="select($event)" :disabled="item.state_id == remitosWS.STATE_BILLED" />
              </td>
              <td>{{ item.cbte_fch }}</td>
              <td>{{ item.remito_label }}</td>
              <td>{{ item.supplier_name }}</td>
              <td>{{ item.receiver_name }}</td>

              <td>{{ item.spent_id != null ? item.spent_label : "-" }}</td>
              <td v-if="isProductCompany()" class="text-center">
                <v-tooltip bottom v-if="item.stock_purchase_remito">
                  <template v-slot:activator="{ on }">
                    <v-chip small color="success" v-on="on">
                      <v-icon small left>mdi-package-variant</v-icon>
                      {{ item.warehouse_name ? item.warehouse_name : 'Stock' }}
                    </v-chip>
                  </template>
                  <span>Remito con stock {{ item.inventory_operation_id ? '(IO: ' + item.inventory_operation_id + ')' : '' }}</span>
                </v-tooltip>
                <v-chip small v-else>
                  <v-icon small left>mdi-package-variant-closed</v-icon>
                  Sin stock
                </v-chip>
              </td>
              <!--<td>{{ item.state_name }}</td>-->
              <td class="text-center px-0">
                <v-menu offset-y v-if="item.has_file">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="grey" class="mr-2" v-bind="attrs" v-on="on">
                      mdi-paperclip
                    </v-icon>
                  </template>
                  <v-list>
                    <v-list-item dense @click="viewComprobante(item)">
                      <v-list-item-title>Ver Adjunto</v-list-item-title>
                    </v-list-item>
                    <v-list-item dense @click="confirmDeleteComprobante(item)">
                      <v-list-item-title>Eliminar Adjunto</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
             
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(item)"> remove_red_eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="violet" class="mr-2" @click="assignGasto(item)"> post_add </v-icon>
                  </template>
                  <span v-if="item.spent_id != null">Reasignar gasto</span>
                  <span v-else>Asignar gasto</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.state_id == remitosWS.STATE_UNBILLED">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(item)"> delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
      <DialogLoading :dialog="dialog_loading" text="Cargando..." />
      
      <DialogYesNo :open="dialog_delete_comprobante" :title="'Confirmar eliminación'" 
        :message="'¿Estás seguro de eliminar el adjunto?'" :loading="loading_delete_comprobante"
        @accept="deleteComprobanteConfirm" @cancel="cancelDeleteComprobante" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { emmiterService } from "@/libs/ws/emmiterService";
import { receiversService } from "@/libs/ws/receiversService";
import { generalService } from "@/libs/ws/generalService";
import { purchaseRemitoService } from "@/libs/ws/purchaseRemitoService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import ModalPurchaseRemito from "@/views/PurchaseRemitos/ModalPurchaseRemito.vue";
import DialogGenerarSpent from "@/views/Spents/DialogGenerarSpent.vue";
import ModalAsignacionGasto from "@/views/PurchaseRemitos/ModalAsignacionGasto.vue";
import DialogLoading from "@/components/DialogLoading.vue";
import { suppliersService } from "@/libs/ws/suppliersService";
export default {
  components: { Title, DialogDelete, DialogYesNo, ModalPurchaseRemito, DialogGenerarSpent, ModalAsignacionGasto, DialogLoading },
  mixins: [GenericMixin, RolMixin, SettingsMixin],
  data() {
    return {
      remitoAsignacionGasto: null,
      dialogAsignacionGasto: false,
      spent_to_generate: null,
      purchase_remito_to_generate: null,
      open_generate_spent: false,
      selected: [],
      remitosWS: purchaseRemitoService,
      formatUtils: formatUtils,
      parent: this,
      service: purchaseRemitoService,
      page_title: "Remitos",
      modal_title: "Remito",
      mainItem: {
        id: 0,
        receiver: null,
        voucher: null,
        observation: null,
        shipping_address: null,
        num_remito: null,
        items: [],
        cbte_fch: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
      },
      dialog_delete: false,
      title_dialog: "",
      message_dialog: "",
      item_dialog: null,
      defaultItem: null,
      headers: [],
      base_headers: [
        { text: "Fecha", align: "left", sortable: true, value: "cbte_fch" },
        { text: "Remito", align: "left", sortable: true, value: "remito_label" },
        { text: "Proveedor", align: "left", sortable: true, value: "supplier_name" },
        { text: "Receptor", align: "left", sortable: true, value: "receiver_name" },
        { text: "Gasto", align: "left", sortable: true, value: "spent_label" },
      ],
      stock_header: { text: "Stock", align: "center", sortable: true, value: "stock_purchase_remito" },
      action_header: { text: "Accion", value: "", align: "center" },
      list: [],
      receivers: [],
      suppliers: [],
      states: [],
      desde_selected_open: false,
      hasta_selected_open: false,
      receiver_selected: null,
      supplier_selected: null,
      state_selected: null,
      stock_selected: null,
      spent_number_selected: null,
      remito_number_selected: null,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      presentations: [],
      dialog_loading: false,
      dialog_delete_comprobante: false,
      loading_delete_comprobante: false,
      item_delete_comprobante: null,
      stock_options: [
        { id: '1', name: 'Con stock' },
        { id: '0', name: 'Sin stock' }
      ],
    };
  },
  mounted() {
    this.buildHeaders();
    this.loadComboData();
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.filter();
  },
  watch: {
    settings() {
      this.buildHeaders();
    },
  },
  methods: {
    buildHeaders() {
      this.headers = [...this.base_headers];
      
      // Solo agregar columna Stock si es empresa de productos
      if (this.isProductCompany()) {
        this.headers.push(this.stock_header);
      }
      
      // Siempre agregar la columna de acciones al final
      this.headers.push(this.action_header);
    },
    //El listado trae filas planas: para los modales se pide el objeto completo por id
    async requestRemito(id) {
      try {
        const response = await this.service.get(id);
        if (response.status === true) return response.result;
        this.$toast.error(response.msg, "Error");
      } catch (e) {
        console.log("purchaseRemitoService.get error");
        console.log(e);
        this.$toast.error("Error al obtener el remito", "Error");
      }
      return null;
    },
    async fetchRemito(id) {
      this.dialog_loading = true;
      const remito = await this.requestRemito(id);
      this.dialog_loading = false;
      return remito;
    },
    //Sobrescriben GenericMixin: la fila del listado no alcanza para el modal
    async viewItem(item) {
      await this.openRemitoModal(item, false);
    },
    async editItem(item) {
      this.errors.clear();
      await this.openRemitoModal(item, true);
    },
    async openRemitoModal(item, is_edit) {
      const remito = await this.fetchRemito(item.id);
      if (remito == null) return;

      const index = this.list.indexOf(item);
      this.editedIndex = is_edit ? index : -1;
      this.viewdIndex = is_edit ? -1 : index;
      this.mainItem = remito;
      this.dialog = true;
    },
    async assignGasto(item) {
      const remito = await this.fetchRemito(item.id);
      if (remito == null) return;

      this.remitoAsignacionGasto = remito;
      this.dialogAsignacionGasto = true;
    },
    closeDialog() {
      this.item_dialog = null;
      this.title_dialog = "";
      this.message_dialog = "";
    },
    getFilterParams() {
      const param = {
        raw: true, //El listado se resuelve por SQL: filas planas, sin objetos de Doctrine
        from: this.desde_selected,
        to: this.hasta_selected,
        receiver: this.receiver_selected != null ? this.receiver_selected.id : null,
        supplier: this.supplier_selected != null ? this.supplier_selected.id : null,
        state: this.state_selected != null ? this.state_selected.id : null,
        spent_number: this.spent_number_selected,
        remito_number: this.remito_number_selected,
        stock_purchase_remito: this.stock_selected != null ? this.stock_selected.id : null,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadComboData() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.receivers = response.result;
      });

      suppliersService
        .filterMinify()
        .then((response) => {
          this.suppliers = response.result;
        })
        .catch((e) => {
          console.log("suppliers.filter error");
          console.log(e);
        });

      this.service
        .get_states()
        .then((response) => {
          this.states = response.result;
        })
        .catch((e) => {
          console.log("states.filter error");
          console.log(e);
        });
    },
    deleteItemConfirm() {
      this.loading = true;
      this.service
        .remove({ id: this.deleteId })
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.filter();
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("spentService.filter error");
          console.log(e);
          this.$toast.error("Error exception", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
      this.dialog_delete = false;
    },

    async generateSpentModal() {
      try {
        // Solo se puede generar gasto para un remito a la vez
        if (this.selected.length != 1) {
          this.$toast.error("Debe seleccionar exactamente un remito de compra", "Error");
          return;
        }

        // Verificar que el remito no esté ya vinculado a un gasto
        if (this.selected[0].state_id == this.remitosWS.STATE_BILLED) {
          this.$toast.error("El remito ya está vinculado a un gasto", "Error");
          return;
        }

        // La fila del listado no trae los items: se pide el remito completo
        const remito = await this.fetchRemito(this.selected[0].id);
        if (remito == null) return;

        this.dialog_loading = true;

        // Preparar items del gasto desde el remito
        let items_custom = [];
        remito.items.forEach((item) => {
          items_custom.push({
            id: null,
            descripcion: item.descripcion,
            quantity: item.quantity,
            price: 0, // El usuario deberá ingresar el precio
            discount_per: 0,
            discount_imp: 0,
            iva: null,
            sub_cost_center: null,
            product_presentation: item.product_presentation,
          });
        });

        // Crear el objeto spent prellenado con datos del remito
        this.spent_to_generate = {
          id: 0,
          warehouse: remito.warehouse,
          stock_spent: true, // Por defecto con stock ya que viene de un remito
          voucher_number: null,
          supplier: remito.supplier,
          receiver: remito.receiver,
          cbte_tipo: null,
          cbte_fch: remito.cbte_fch,
          cbte_fch_serv_desde: remito.cbte_fch,
          cbte_fch_serv_hasta: remito.cbte_fch,
          fch_vto_pago: remito.cbte_fch,
          concepto: null,
          moneda: null,
          mon_cotiz: 1,
          items_custom: items_custom,
          tributes: [],
          cbtes_asoc: [],
          observation: remito.observation,
          purchase_remito_id: remito.id,
        };

        this.purchase_remito_to_generate = remito;

        this.dialog_loading = false;
        this.open_generate_spent = true;
      } catch (e) {
        this.dialog_loading = false;
        console.error("Error al generar gasto:", e);
        this.$toast.error("Error al preparar el gasto", "Error");
      }
    },
    closeSpent() {
      this.spent_to_generate = null;
      this.purchase_remito_to_generate = null;
      this.open_generate_spent = false;
      this.selected = [];
    },
    //La url firmada del adjunto se resuelve al momento de abrirlo, no en el listado.
    //La pestaña se abre antes del await para que el navegador no la bloquee.
    async viewComprobante(item) {
      const tab = window.open("", "_blank");
      const remito = await this.fetchRemito(item.id);

      if (remito == null || remito.file_path == null) {
        if (tab != null) tab.close();
        return;
      }

      if (tab != null) tab.location = remito.file_path;
      else window.open(remito.file_path, "_blank");
    },
    confirmDeleteComprobante(item) {
      this.item_delete_comprobante = item;
      this.dialog_delete_comprobante = true;
    },
    cancelDeleteComprobante() {
      this.item_delete_comprobante = null;
      this.dialog_delete_comprobante = false;
      this.loading_delete_comprobante = false;
    },
    deleteComprobanteConfirm() {
      if (!this.item_delete_comprobante) return;
      
      this.loading_delete_comprobante = true;
      this.service
        .deleteComprobante(this.item_delete_comprobante.id)
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.filter();
            this.cancelDeleteComprobante();
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("purchaseRemitoService.deleteComprobante error");
          console.log(e);
          this.$toast.error("Error al eliminar el comprobante", "Error");
        })
        .finally(() => {
          this.loading_delete_comprobante = false;
        });
    },
  },
};
</script>
